// extracted by mini-css-extract-plugin
module.exports = {"pageNF":"Category_pageNF__3ElhL","spinner":"Category_spinner__3XOs3","chart":"Category_chart__1Gw0b","clickablelink":"Category_clickablelink__2QojT"};